export default __webpack_public_path__ + "static/media/i20.ac1ee757.svg";